// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';
import { css } from 'glamor';

import type { MenuEntry } from '~/types';

const entry = css({
    marginTop: '10px',
    fontSize: '1em',
    fontWeight: 300,
});

const entryLink = css({
    color: '#fff',
});

const iconRule = css({
    color: '#fff',
    fontSize: '0.7em',
    margin: '0 7px',
});

@observer
export default class BrowseMenuEntry extends React.Component {
    props: {
        entry: MenuEntry,
        icon: string,
    };

    render() {
        const { label, link, externLink } = this.props.entry;
        const { icon } = this.props;

        return (
            <li { ...entry }>
                {externLink ?
                    <a { ...entryLink } href={ link }>
                          <FontAwesome { ...iconRule } name={ icon } />
                          {label}
                      </a> :
                    <Link { ...entryLink } to={ link }>
                          <FontAwesome { ...iconRule } name={ icon } />
                          {label}
                      </Link>}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/BrowseMenuEntry/index.js